import type { ReactNode } from 'react';

export const symbol_calendar_meal_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M414-350q-42 0-64-28t-33-72h326q-11 44-33 72t-64 28H414Zm-60-160q4-30 23.5-45t42.5-15h49q26-26 38.5-33t32.5-7q29.17 0 49.58 20.42Q610-569.17 610-540v30H354Zm60 220h132q85 0 123.5-62.79T710-510h-40v-30q0-53.86-38.07-91.93Q593.86-670 540-670q-29 0-52.5 10T444-630h-24q-48.4 0-84.7 33-36.3 33-43.3 87h-42q2 94.42 40.5 157.21Q329-290 414-290ZM180-120q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q310-901.6 310-888v28h340v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q715-901.6 715-888v28h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H180Zm600-60v-620H180v620h600Zm-600 0v-620 620Z"
		/>
	</svg>
);
